import React, { ReactNode, useEffect, useRef, useState } from 'react'
import { isChildNode } from '../../helpers'
import { images } from '../../images'
import { Dropdown } from './Dropdown'
import { Item } from './Item'
import StyledDiv from './styles'

interface IProps {
  value: string
  options: any[]
  onChange: (value: any) => void
  placeholder?: string
  className?: string
}

export const Select: React.FC<IProps> = ({ value, options, onChange, placeholder, className }) => {
  const ref = useRef<HTMLDivElement>(null)
  const [ isOpen, setIsOpen ] = useState(false)
  const classNames = `
    select-container
    ${ className || '' }
    ${ value ? 'filled' : '' }
    ${ isOpen ? 'active' : '' }
  `

  const items = (): ReactNode => {
    return options.map((t, i) => (
      <Item
        key={ i }
        isSelected={ value === t.value }
        onClick={ () => handleChange(t.value) }
      >
        { t.label }
      </Item>
    ))
  }

  const handleChange = (option: string) => {
    onChange(option)
    setIsOpen(false)
  }

  const handleDocumentClick = (event: Event) => {
    if ((isOpen && !isChildNode(ref.current, event.target)) || ref.current !== event.target) setIsOpen(false)
  }

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick)

    return () => {
      document.removeEventListener('click', handleDocumentClick)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <StyledDiv
      ref={ ref }
      className={ classNames }
      onClick={ () => setIsOpen(current => !current) }
    >
      <input className="value" placeholder={ placeholder } readOnly value={ value } />
      <img src={ isOpen ? images['up'] : images['down'] } style={{ width: '20px', height: '20px' }} alt="select-arrow"/>
      <Dropdown isHidden={ !isOpen }>{ items() }</Dropdown>
    </StyledDiv>
  )
}
